interface StatusBadgeProps {
    success: boolean;
    rejected?: boolean;
    /** Optional override labels. Defaults: 'Exitoso' / 'Fallido' / 'Rechazado' */
    labels?: { success: string; failure: string; rejected: string };
}

/** Pill badge: green for success, amber for rejected, red for failure. */
export default function StatusBadge({
    success,
    rejected = false,
    labels = { success: 'Exitoso', failure: 'Fallido', rejected: 'Rechazado' },
}: StatusBadgeProps) {
    let className: string;
    let label: string;

    if (success) {
        className = 'bg-success-50 border border-success-200 text-success-700';
        label = labels.success;
    } else if (rejected) {
        className = 'bg-amber-50 border border-amber-300 text-amber-700';
        label = labels.rejected;
    } else {
        className = 'bg-danger-50 border border-danger-200 text-danger-700';
        label = labels.failure;
    }

    return (
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${className}`}>
            {label}
        </span>
    );
}
